/* -------------------------------------------------------------------------- */
/* --------------------------- THEME : FRAMEWORKS --------------------------- */

// FRAMEWORKS : NODES_MODULES
import gsap from "gsap";

/* -------------------------------------------------------------------------- */
/* ------------------------- THEME : GLOBAL EVENTS -------------------------- */

// DOCUMENT READY :
document.addEventListener("DOMContentLoaded", () => {
	if (document.querySelector("#registration")) {
		initStep(1);
	}
});

// ELEMENTS "CLICK" :
const stepPrev = document.querySelector("#registration #step-prev");
if (stepPrev) {
	stepPrev.addEventListener("click", () => {
		if (stepPrev.classList.contains("button-disabled")) return;
		const currentStep = getCurrentStep();
		initStep(currentStep - 1);
	});
}

const stepNext = document.querySelector("#registration #step-next");
if (stepNext) {
	stepNext.addEventListener("click", () => {
		if (stepNext.classList.contains("button-disabled")) return;
		const currentStep = getCurrentStep();
		initStep(currentStep + 1);
	});
}

// ELEMENTS "CHANGE" :
const stepFields = document.querySelectorAll(
	"#registration input, #registration select, #registration textarea"
);
if (stepFields) {
	stepFields.forEach((input) => {
		input.addEventListener("input", () => checkCurrentStep());
	});
}

/* -------------------------------------------------------------------------- */
/* ----------------------- THEME : GLOBAL FUNCTIONS ------------------------- */

// Retourner le nombre total d'étapes
function getTotalStep() {
	const steps = document.querySelectorAll("#registration form > fieldset.form__fieldset");
	return steps.length;
}

// Retourner l'index de l'étape en cours
function getCurrentStep() {
	const steps = document.querySelectorAll("#registration form > fieldset.form__fieldset");
	const currentStep = document.querySelector(
		"#registration form > fieldset.form__fieldset.--active"
	);
	const index = Array.from(steps).indexOf(currentStep);
	return index + 1;
}

// Mise à jour des informations de progression
function updateProgress() {
	const currentStep = getCurrentStep();
	const totalStep = getTotalStep();

	// Mettre à jour les labels
	const stepCurrentLabel = document.querySelector("#step-current");
	const stepTotalLabel = document.querySelector("#step-total");
	if (stepCurrentLabel && stepTotalLabel) {
		stepCurrentLabel.innerHTML = currentStep;
		stepTotalLabel.innerHTML = totalStep;
	}

	// Mettre à jour la barre de progression
	const progressBar = document.querySelector(
		"#step-progress .form__progress__bar > div"
	);
	if (progressBar) {
		progressBar.style.width = (currentStep / totalStep) * 100 + "%";
	}
}

// Gestion du bouton "suivant"
function checkCurrentStep() {
	const currentStep = document.querySelector(
		"#registration form > fieldset.form__fieldset.--active"
	);
	if (!currentStep) return;

	// Récupération des champs
	const currentStepFields = currentStep.querySelectorAll(
		':is(input, select, textarea)[aria-required="true"]'
	);

	// Vérifications
	let csfValidity = true; // supposition initiale
	currentStepFields.forEach((field) => {
		if (!field.value || !field.checkValidity()) {
			csfValidity = false;
		}
	});

	// Actions
	if (csfValidity) {
		stepNext.classList.remove("button-disabled");
	} else {
		stepNext.classList.add("button-disabled");
	}
}

// Chargement d'une nouvelle étape
const initStep = (index = 1) => {
	// console.log("init step: ", index);
	const totalStep = getTotalStep();

	// Activer le nouvelle étape
	if (0 < index && index <= totalStep) {
		// Vérifier l'existence de l'étape demandée
		const stepToActive = document.querySelector(
			`#registration form > fieldset.form__fieldset:nth-child(${index + 1})`
		);
		if (stepToActive) {
			// Désactiver toutes les étapes en cours
			const activeSteps = document.querySelectorAll(
				"#registration form > fieldset.form__fieldset.--active"
			);
			activeSteps.forEach((activeStep) => {
				activeStep.classList.remove("--active");
			});

			// Activer l'étape demandée
			stepToActive.classList.add("--active");

			// Activer / désactiver le bouton "précédent"
			if (index == 1) {
				stepPrev.classList.add("button-disabled");
			} else {
				stepPrev.classList.remove("button-disabled");
			}

			// Afficher / désactiver les boutons "suivant" et "submit"
			const stepFinal = document.querySelector("#step-final");
			if (index == totalStep) {
				stepNext.style.display = "none";
				stepFinal.style.display = "block";
			} else {
				stepNext.style.display = "block";
				stepFinal.style.display = "none";
			}

			// MAJ de la progression
			updateProgress();

			// Vérification initiale
			checkCurrentStep();
		}
	} else {
		console.log(`étape ${index} introuvable`);
	}
};
